import {Routes} from "@angular/router";
import {Constants} from "./modules/constants";
import {KrEnrollAuthComponent} from "./modules/enroll/personal-authentication/kr-enroll-auth/kr-enroll-auth.component";

// Minimal routes for the standalone direct route bootstrap
export const directRoutes: Routes = [
    { path: 'direct/'+ Constants.ENROLL_KRAUTH_STATE, component: KrEnrollAuthComponent },
    { path: ':locale/direct/' + Constants.ENROLL_KRAUTH_STATE, component: KrEnrollAuthComponent },
];

